export function gravityFormFilters() {

    if (typeof gform !== 'undefined') {
        gform.addFilter('gform_file_upload_markup', function (html, file, up, strings, imagesUrl) {
            const formId = up.settings.multipart_params.form_id;
            const fieldId = up.settings.multipart_params.field_id;
            let newHtml = `<strong class="file-upload__title"> ${file.name}</strong>`

            newHtml += `<button class='gform_delete file-upload__remove' onclick='gformDeleteUploadedFile(${formId},${fieldId},this);'>Remove</button> `;
            return newHtml;
        });
    }

}